import React, { FC, memo } from 'react';
import {Link} from 'react-router-dom';
interface IBreadcrumbItem {
  item: any,
}

const BreadcrumbItem : FC <IBreadcrumbItem>= ({item, ...props}) => {

  return (
    <li {...props}>
      {
        item.to ? <Link to={item.to} >{
          item.icon ? <svg><use xlinkHref={item.icon}  /></svg> : item.label
        }</Link> : <span>{item.label}</span>
      }
    </li>
  )
}
export default memo(BreadcrumbItem);
